export const LOADER_STATUS = "boilerplate/Notices/EmailConfig/LOADER_STATUS";
export const EMAIL_TABLE_DATA = "boilerplate/Notices/EmailConfig/EMAIL_TABLE_DATA";
export const GSTINS = "boilerplate/Notices/EmailConfig/GSTINS";
export const SELECTED_GSTIN = "boilerplate/Notices/EmailConfig/SELECTED_GSTIN";
export const ACTIVE_TAB = "boilerplate/Notices/EmailConfig/ACTIVE_TAB";

